// extracted by mini-css-extract-plugin
export default {"analyticsRainfall":"Rainfall_analyticsRainfall__QSsFo","month":"Rainfall_month__mDBE6","month-cell":"Rainfall_month-cell__QtOVi","legend-font":"Rainfall_legend-font__qlP76"};